import React, { useState } from 'react'
import '../styles/LoginStyle.css'
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../firebase/firebase';
import LoginHeader from './LoginHeader';

function Login() {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  onAuthStateChanged(auth, (user) => {
          if(user) {
              document.getElementById('formField').style = "visibility: hidden"
          } else {
              //document.getElementById('logoutButton').style = "visibility: visible"
          }
      })

  const loginMessage = document.getElementById('loginMessage');

  const handleSubmit = async(e) => {
    e.preventDefault();
    try {
        await signInWithEmailAndPassword(auth, `${username}@chimera.com`, password);


        // login was successful
        if(loginMessage != null) {

        loginMessage.style = "visibility: visible"
        loginMessage.style = "color: green"
        loginMessage.innerHTML = "access granted! You will be redirected..."
        
        setTimeout(() => {
            loginMessage.style = "visibility: hidden";
    }, 5000);
    setTimeout(() => {
            window.location.href = "/";
    }, 5000);
    
  }

    const authUser = getAuth();
    console.log(authUser);

    document.getElementById('formField').style = 'visibility: hidden';

    } catch (error) {

      if(loginMessage != null) {
        loginMessage.style = "visibility: visible"
        loginMessage.style = "color: red"
        loginMessage.innerHTML = "access denied";
        
    setTimeout(() => {
      loginMessage.style = "visibility: hidden";
    }, 5000);
  }

    const authUser = getAuth();
    console.log(authUser);
  };
        
  }

  return (
    <div>
    <LoginHeader />
    <div id='loginDiv'>
      <form id='formField' onSubmit={handleSubmit}>
        <label id='loginText'>ログイン</label>
        <input
            placeholder='username'
            type='text'
            id='usernameField'
            className='flicker'
            value={username}
            onChange={(e) => setUsername(e.target.value)} />
        <input 
            placeholder='password'
            type='password'
            id='passwordField' 
            className='flicker' 
            value={password}
            onChange={(e) => setPassword(e.target.value)} />
        <button
            type='submit'
            id='submitButton'
            className='flickerButton'>Login</button>
      </form>
        <p id='loginMessage'></p>
    </div>
    </div>
  )
}

export default Login
